var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLabel = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M.7.003 7.01.45a.72.72 0 0 1 .455.208l8.24 8.241c.4.4.4 1.056 0 1.456l-5.346 5.347c-.4.4-1.056.4-1.455 0L.662 7.46a.72.72 0 0 1-.208-.455L.009.77C-.035.424.294-.023.7.003m3.59 3.2a1.06 1.06 0 0 0-.769.312 1.06 1.06 0 0 0 0 1.506c.42.42 1.085.419 1.504 0a1.06 1.06 0 0 0 0-1.506 1.06 1.06 0 0 0-.736-.312"
})));
export default SvgLabel;